import { Card } from 'primereact/card'
import React from 'react'

export const Home = () => {
    return (
        <Card title="Welcome to Project Diction!" subTitle="Soon you can begin your language journey here!" className="">
        </Card>
    )
}
